export default __webpack_public_path__ + "static/media/SHRIKANT_JALIHAL.3bbadcc8.JPG";